const ORIGIN_CITIES = {
  UK: [
    {
      id: 26,
      placeName: 'London'
    },
    {
      id: 28,
      placeName: 'Birmingham'
    },
    {
      id: 29,
      placeName: 'Bristol'
    },
    {
      id: -1,
      placeName: 'Glasgow'
    },
    {
      id: 22371862,
      placeName: 'Edinburgh'
    },
    {
      id: 34,
      placeName: 'Manchester'
    },
    {
      id: 55594151,
      placeName: 'Plymouth'
    },
    {
      id: 40,
      placeName: 'York'
    }
  ],
  EU: [
    {
      id: 22371672,
      placeName: 'Paris'
    },
    {
      id: 22370615,
      placeName: 'Frankfurt'
    },
    {
      id: 22371727,
      placeName: 'Munich'
    },
    {
      id: 22370679,
      placeName: 'Madrid'
    },
    {
      id: 22370654,
      placeName: 'Amsterdam'
    },
    {
      id: 22371674,
      placeName: 'Zurich'
    },
    {
      id: 55594037,
      placeName: 'Geneva'
    },
    {
      id: 22394314,
      placeName: 'Copenhagen'
    },
    {
      id: 22371719,
      placeName: 'Rome'
    }
  ]
};

const BLUEPRINT_ORIGIN_CITIES = {
  UK: ['Birmingham', 'Bristol', 'Edinburgh', 'Glasgow', 'London', 'Manchester', 'Plymouth', 'York'],
  EU: ['Paris']
};

export { ORIGIN_CITIES, BLUEPRINT_ORIGIN_CITIES };
